// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3082":"ee7ca9a9","3632":"49677fef","6743":"91ec1f1f","9969":"65426b67"}[chunkId] + ".chunk.css";
};